export const BASE_URL = 'https://biz.giftishow.com';
export const BASE_URL_MOBILE = 'https://mbiz.giftishow.com';

export const DEFAULT_TITLE = '기업 기프티콘, 판촉물제작, 모바일 쿠폰 발송 서비스 1위';

export const generateTitle = title => {
	return `${title} | ${DEFAULT_TITLE}`;
};

export const generateCanonicalLink = (path, baseUrl = BASE_URL) => ({
	rel: 'canonical',
	href: `${baseUrl}${path}`,
});
